import {
  Card,
  Heading,
  IconTick,
  List,
  Stack,
  Text,
} from 'braid-design-system';

import type { ListingProduct } from 'src/generated/graphql';

interface AccelerateProductDetailsProps {
  product: ListingProduct;
}

export const AccelerateProductDetails = (
  props: AccelerateProductDetailsProps,
) => (
  <Card data={{ testid: 'accelerate-product-details' }}>
    <Stack space="large">
      <Heading level="4" component="h3">
        Purchase Accelerate List Until Sold ad
      </Heading>

      <List type="icon" icon={<IconTick tone="positive" />}>
        {[
          "Appear on Australia's #1 business marketplace",
          'List until your business sells',
          'Connect with interested buyers',
          'Photo included in search results',
          'Appear higher in search results',
          'Feature at the top of search results',
          'Included in daily buyer recommendation emails',
          'Priority placement in daily buyer recommendation emails',
        ].map((feature, i) => (
          <Text key={i}>{feature}</Text>
        ))}
      </List>

      <Text size="large" data={{ testid: 'accelerate-product-details-price' }}>
        ${props.product.cost / 100} + GST
      </Text>
    </Stack>
  </Card>
);
